const customerNames = ['Louisa K.', 'Haris O.', 'Alexa I.'];
const memberNames = ['Jennie P.', 'Alex S.'];

const customerPrompts = [
  'Do you have a table for two tonight?',
  'Are you still open right now?',
  'Can I reserve for a group this evening?',
];

const memberPrompts = [
  'A group booking just came in for this evening.',
  'Can you confirm the prep list for tonight?',
];

const hashValue = (value = '') => {
  return value.split('').reduce((sum, char) => sum + char.charCodeAt(0), 0);
};

export const buildVenueConversations = (venue) => {
  const venueName = venue?.restaurant_name || 'your venue';
  const seed = hashValue(venue?.id || venueName);

  const conversations = [
    {
      id: 'venue-customer-1',
      name: customerNames[seed % customerNames.length],
      message: `${customerPrompts[seed % customerPrompts.length]} (${venueName})`,
      type: 'customer',
      online: seed % 2 === 0,
      unread: 1,
    },
    {
      id: 'venue-customer-2',
      name: customerNames[(seed + 1) % customerNames.length],
      message: `Is ${venueName} available for a late dinner?`,
      type: 'customer',
      online: false,
      unread: 0,
    },
    {
      id: 'venue-member-1',
      name: memberNames[seed % memberNames.length],
      message: memberPrompts[seed % memberPrompts.length],
      type: 'member',
      online: false,
      unread: 0,
      isAdmin: true,
    },
    {
      id: 'venue-member-2',
      name: memberNames[(seed + 1) % memberNames.length],
      message: `Can you check the service notes for ${venueName}?`,
      type: 'member',
      online: seed % 3 === 0,
      unread: 0,
      isAdmin: false,
    },
  ];

  return conversations;
};

export const buildVenueConversationMap = (venue) => {
  const venueName = venue?.restaurant_name || 'your venue';
  const conversations = buildVenueConversations(venue);

  return conversations.reduce((acc, conversation, index) => {
    acc[conversation.id] = {
      name: conversation.name,
      messages: [
        { id: `${conversation.id}-1`, from: 'them', text: conversation.message },
        {
          id: `${conversation.id}-2`,
          from: 'me',
          text: index < 2
            ? `Thanks for reaching out about ${venueName}. We can help.`
            : `Got it — I’m checking that for ${venueName} now.`,
        },
      ],
    };
    return acc;
  }, {});
};